module.exports = {
  DEV_CONSOLE_URL: process.env.REACT_APP_DEVCONSOLE,
  DEV_AUTH_URL: process.env.REACT_APP_DEVAUTH,
  APP_MANAGEMENT_URL: process.env.REACT_APP_MANAGEMENT,
  APP_ANALYTICS_URL: process.env.REACT_APP_ANALYTICS,
  APP_ANALYTICS_URL_OLD: process.env.REACT_APP_ANALYTICS_OLD,
  DC_CONSUMER_URL: process.env.REACT_APP_CONSUMER_URL,
  DC_ENTERPRISE_URL: process.env.REACT_APP_ENTERPRISE_URL,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  /** When true, use custom captcha (GET captcha/generate + userInput/encryptedData). Otherwise Google reCAPTCHA. */
  USE_CUSTOM_CAPTCHA: process.env.REACT_APP_USE_CUSTOM_CAPTCHA === "true",
};